import Colors from '../../../../shared/assets/style/default/color';
import Props from '../../../../shared/types/props/button';
import Screen from '../../../../shared/utils/screen';

function RecordCancelIcon({ focused }: Props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={`${32 * Screen.widthRatio}`}
      height={`${32 * Screen.widthRatio}`}
      viewBox={'0 0 50 50'}
    >
      <path
        d='M25 2.72191e-06C38.8071 2.11838e-06 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 -4.89256e-07 38.8071 -1.09278e-06 25C-1.69631e-06 11.1929 11.1929 3.32544e-06 25 2.72191e-06ZM25 45.8061C36.4909 45.8061 45.8061 36.4909 45.8061 25C45.8061 13.5091 36.4909 4.19394 25 4.19394C13.5091 4.19394 4.19393 13.5091 4.19393 25C4.19393 36.4909 13.5091 45.8061 25 45.8061Z'
        fill={focused ? Colors['dark'] : Colors['light']}
      />
      <path
        d='M46 25C46 36.598 36.598 46 25 46C13.402 46 4 36.598 4 25C4 13.402 13.402 4 25 4C36.598 4 46 13.402 46 25Z'
        fill='#D20000'
      />
      <path
        d='M15 19C15 16.7909 16.7909 15 19 15H31C33.2091 15 35 16.7909 35 19V31C35 33.2091 33.2091 35 31 35H19C16.7909 35 15 33.2091 15 31V19Z'
        fill='white'
      />
    </svg>
  );
}

export default RecordCancelIcon;
